import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
export class PrefixService {
    constructor() {}
    
    selectedBranchPrefix = new BehaviorSubject<string>('');
    selectedBranchPrefixObs = this.selectedBranchPrefix.asObservable();

    changeBranchPrefix(prefix: string) {
        this.selectedBranchPrefix.next(prefix);
    }

    selectedProductPrefix = new BehaviorSubject<string>('');
    selectedProductPrefixObs = this.selectedProductPrefix.asObservable();

    changeProductPrefix(prefix: string) {
        this.selectedProductPrefix.next(prefix);
    }
}